// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import {IProductEnvironment} from "./FacilitiesEvaluationEnvironment";
import {FacilityAccessibilityProduct} from "../product.facility/model/FacilityAccessibilityProduct";
import {EProductType} from "../javascript.lib.mojo-base/model/ProductType";
import {FacilityAccessibilityProduct2} from "../product.facility/model/FacilityAccessibilityProduct2";
import {FacilityAccessibilityProduct3} from "../product.facility/model/FacilityAccessibilityProduct3";
import {FacilityAccessibilityProduct4} from "../product.facility/model/FacilityAccessibilityProduct4";

export const environment: IProductEnvironment = {

  name: 'Beiersdorf: Manufacturing',
  filename: 'environment.manufacturing-666973.ts',

  isDevelopment: false,
  isProduction: true,
  isTest: false,

  authenticationConfig: {

    emailLink: false,
    textMessage: true,
    usernamePassword: true
  },


  firebaseConfig: {
    apiKey: "AIzaSyBboSe2qYjIgkxT0KmTrLvONnlWrB43tes",
    authDomain: "manufacturing-666973.firebaseapp.com",
    databaseURL: "https://manufacturing-666973-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "manufacturing-666973",
    storageBucket: "manufacturing-666973.appspot.com",
    messagingSenderId: "413415547445",
    appId: "1:413415547445:web:20aa0e7cc60b1853a5077c"
  },

  // curl -iLS https://us-central1-$_TARGET_ENV.cloudfunctions.net/public/functions/info
  cloudFunctionsUrl: 'https://us-central1-manufacturing-666973.cloudfunctions.net',

  nocoDbConfig: {
    // httpServer: 'http://localhost:8080',
    httpServer: 'https://mobilitymojo-spot.com',
    user: 'test@mobilitymojo.com',
    password: 'test@mobilitymojo.com',
    authorization: 'Basic bW9iaWxpdHk6bW9qbw==',
    projectTitle: '2024 - Grosvenor and The Crown Estate',
  },

  productConfig: {

    firebaseAnswersRoot: '/answers-x/manufacturing',
    // product:  ProductHelper.cloneProduct( new FacilityAccessibilityProduct(), true )
    // product:  FacilityAccessibilityProduct3.INSTANCE
    product:  FacilityAccessibilityProduct4.INSTANCE,
    productType: EProductType.manufacturing,
    canCommentOnClusters: true,
    canEditClusters: false,
    clusterSupport: true,

  },




};
